<ng-container *ngIf="companies?.length">
    <div class="c-company-selector__companies-list">
        <div class="c-list x-company-list-wrapper">
    
            <div class="c-list__item c-list__item--rounded is-clickable"
                *ngFor="let availableCompany of companies; let last = last;"
                [class.mb-0]="last"
                [class.mb-2]="!last"
                (click)="changeCompany(availableCompany)">
                <pay-avatar class="mr-3"
                    [isSingleInitial]="true"
                    [class.c-avatar--admin]="availableCompany.role === ACCOUNT_ROLE.ADMIN"
                    [class.c-avatar--manager]="availableCompany.role === ACCOUNT_ROLE.MANAGER"
                    [user]="availableCompany"></pay-avatar>
                {{ availableCompany.name }}
                <pay-icon name="check" class="ml-auto c-icon--sm mr-2"
                    *ngIf="availableCompany?.id === company?.id"></pay-icon>
            </div>
        </div>
    </div>
    <div class="c-company-selector__divider"></div>
</ng-container>
